import React, { useState } from "react";

const useTableSort = () => {
  const [sortConfig, setSortConfig] = useState([]);
  const handleClickColumnSort = (dataKey) => {
    setSortConfig((prevConfig) => {
      const newConfig = [...prevConfig];
      const configIndex = newConfig.findIndex((item) => item.key === dataKey);
      if (configIndex !== -1) {
        // If the key already exists
        if (newConfig[configIndex].direction === "asc") {
          // If it's ascending, change to descending
          newConfig[configIndex].direction = "desc";
        } else {
          // If it's descending, remove it
          newConfig.splice(configIndex, 1);
        }
      } else {
        // If it's a new key, add it to the beginning of the array with ascending order
        newConfig.unshift({ key: dataKey, direction: "asc" });
      }
      // Limit to a maximum of 2 sort fields (you can adjust this number)
      return newConfig;
    });
  };

  return { sortConfig, setSortConfig, handleClickColumnSort };
};

export default useTableSort;
